import React from 'react';
import BottomNav from '../components/BottomNav';

const PreviewSupport = () => {
  return (
    <div className="min-h-screen bg-[#FAFAF9] page-container pb-safe pt-safe">
      <div className="max-w-md mx-auto p-6 pt-safe space-y-8">
        <div className="space-y-4">
          <div className="flex justify-between items-center mb-2">
            <h2 className="font-manrope text-2xl font-bold text-stone-900">Storico delle Mie Richieste</h2>
          </div>

          <div className="space-y-3">
            <button className="w-full text-left p-5 hover:bg-stone-50 transition-all shadow-sm focus:ring-2 focus:ring-stone-300 font-manrope">
              <div className="flex justify-between items-start mb-2">
                <h3 className="font-sans font-semibold text-stone-900">Esempio: Problema login</h3>
                <span className="px-3 py-1 rounded-full text-xs font-semibold tracking-wide bg-blue-100 text-blue-800">Aperta</span>
              </div>
              <p className="text-stone-600 text-sm mb-2">Non riesco ad accedere con Google, appare errore 401...</p>
              <div className="text-xs text-stone-500">Support • Creato il 14/02/2026</div>
            </button>
          </div>
        </div>
      </div>
      <BottomNav currentPage="support" />
    </div>
  );
};

export default PreviewSupport;
